import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Compass, BookOpen, Hash, Settings, Tv } from "lucide-react";

const RUINS = "https://images.unsplash.com/photo-1565799446045-5ba401561908";

const GAMES = [
  {
    id: "biblico", route: "/biblico", icon: BookOpen,
    title: { es: "Archivo Bíblico Perdido", en: "The Lost Bible Archive" },
    desc: { es: "Expedición familiar para recuperar las 3 piezas perdidas.", en: "A family expedition to recover the 3 lost pieces." },
    accent: "#C89B3C",
  },
  {
    id: "serie", route: "/serie", icon: Hash,
    title: { es: "Serie Secreta", en: "Secret Series" },
    desc: { es: "Con tus cartas UNO reales: completa tu serie secreta de 5 números y gana.", en: "With your real UNO cards: complete your secret 5-number series and win." },
    accent: "#2e86ab",
  },
];

export default function GameMenu() {
  const nav = useNavigate();
  const [lang, setLang] = useState("es");

  return (
    <div className="relative min-h-screen overflow-hidden grain tv-vignette">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${RUINS})` }} />
      <div className="absolute inset-0 bg-gradient-to-t from-midnight via-midnight/90 to-midnight/70" />

      <div className="absolute top-6 right-6 z-20 flex gap-2">
        {["es", "en"].map((l) => (
          <button key={l} data-testid={`menu-lang-${l}`} onClick={() => setLang(l)}
            className={`px-4 py-2 rounded-full text-sm font-semibold btn-tactile border ${lang === l ? "bg-bronze text-midnight border-bronze/60" : "glass text-parchment border-bronze/30"}`}>
            {l === "es" ? "🇪🇸 ES" : "🇺🇸 EN"}
          </button>
        ))}
      </div>

      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 py-16 max-w-5xl mx-auto text-center">
        <div className="animate-fade-in flex items-center gap-3 text-bronze mb-6">
          <Compass className="w-8 h-8 animate-spin-slow" style={{ animationDuration: "12s" }} />
          <span className="uppercase tracking-[0.35em] text-xs font-semibold text-sand">{lang === "es" ? "Noche de Juegos" : "Game Night"}</span>
        </div>
        <h1 className="font-display font-800 text-5xl sm:text-6xl leading-none text-parchment text-shadow-lg animate-fade-up">
          {lang === "es" ? "Elige un juego" : "Choose a game"}
        </h1>
        <p className="mt-5 text-sand/80 text-base sm:text-lg animate-fade-up" style={{ animationDelay: "0.1s" }}>
          {lang === "es" ? "La TV es el tablero. Tu teléfono es el control." : "The TV is the board. Your phone is the controller."}
        </p>

        <div className="mt-12 grid sm:grid-cols-2 gap-6 w-full">
          {GAMES.map((g, i) => (
            <button key={g.id} data-testid={`menu-game-${g.id}`} onClick={() => nav(g.route)}
              className="group glass btn-tactile rounded-3xl p-8 text-left border-2 transition-all hover:-translate-y-1"
              style={{ borderColor: `${g.accent}66`, animationDelay: `${0.15 + i * 0.1}s` }}>
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-5 transition-transform group-hover:scale-110" style={{ background: `${g.accent}22`, border: `1px solid ${g.accent}66` }}>
                <g.icon className="w-8 h-8" style={{ color: g.accent }} />
              </div>
              <div className="font-serif text-3xl text-parchment">{g.title[lang]}</div>
              <div className="text-sand/70 text-sm mt-2 leading-relaxed">{g.desc[lang]}</div>
              <div className="mt-5 inline-flex items-center gap-2 text-sm font-semibold" style={{ color: g.accent }}>
                <Tv className="w-4 h-4" /> {lang === "es" ? "Jugar" : "Play"}
              </div>
            </button>
          ))}
        </div>

        <button data-testid="menu-admin-btn" onClick={() => nav("/admin")}
          className="mt-10 inline-flex items-center gap-2 text-sand/60 hover:text-bronze transition-colors text-sm">
          <Settings className="w-4 h-4" /> {lang === "es" ? "Administrar contenido" : "Manage content"}
        </button>
      </div>
    </div>
  );
}
